import { render, staticRenderFns } from "./authLayout.vue?vue&type=template&id=ba2e750a&scoped=true"
import script from "./authLayout.vue?vue&type=script&lang=js"
export * from "./authLayout.vue?vue&type=script&lang=js"
import style0 from "./authLayout.vue?vue&type=style&index=0&id=ba2e750a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba2e750a",
  null
  
)

export default component.exports